module.exports = __webpack_public_path__ + "img/ic-5.b3acda1.svg";